import { Injectable } from '@angular/core';
import { Customization } from './model/customization.model';
import { Store } from '@ngrx/store';
import { CustomizationActions, CustomizationApiActions } from './customization.actions';
import { selectCustomization } from './customization.selectors';

@Injectable({
    providedIn: 'root'
})
export class CustomizationFacade {
    customization$ = this.store.select(selectCustomization);

    constructor(private store: Store) {}

    setCustomization(customization: Customization) {
        this.store.dispatch(CustomizationActions.setCustomization({ customization }));
    }

    loadCustomization() {
        this.store.dispatch(CustomizationApiActions.loadCustomization());
    }
}
